export const getCurrencySymbol = (currency?: string): string => {
  if (!currency) return "";

  try {
    const parts = new Intl.NumberFormat("en", {
      style: "currency",
      currency,
    }).formatToParts(0);

    return parts.find((part) => part.type === "currency")?.value ?? currency;
  } catch {
    return currency;
  }
};
